<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="店销信息" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
        </el-header>
        <el-main style="height: 100%">
            <el-form :inline="true" :model="searchParms" size="mini">
                <el-form-item label="品牌门店">
                    <el-cascader :options="storeData" filterable clearable v-model="searchParms.storeStructs" :props="{ checkStrictly: true }" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="inteboNotDePositData" size="mini" style="text-align: center" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        {{scope.row.parentname}}/{{scope.row.storename}}
                    </template>
                </el-table-column>
                <el-table-column label="定金金额"  align="center" prop="deposit"></el-table-column>
                <el-table-column label="支付日期"  align="center" prop="paydate"></el-table-column>
                <el-table-column label="操作"  align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="openPay(scope)" type="text" size="small">退定金</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="退定金" :visible.sync="dialogVisible" width="100%" top="0px" class="notpay" :close-on-click-modal="false">
            <el-form :model="inteboDePostit" size="mini" label-width="80px">
                <el-form-item label="门店">
                    {{inteboDePostit.parentname}}/{{inteboDePostit.storename}}
                </el-form-item>
                <el-form-item label="支付日期">
                    {{inteboDePostit.paydate}}
                </el-form-item>
                <el-form-item label="定金">
                    {{inteboDePostit.deposit}}
                </el-form-item>
                <el-form-item label="返还日期">
                    <el-date-picker size="mini" :editable="false" style="width: 100%" v-model="inteboDePostit.backdate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="updateInteboDeposit()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            queryLoadBtton:false,
            curIndex:0,
            inteboDePostit:{
                parentid:"",
                storeid:"",
                sysbillid:"",
                deposit:0,
                backdate:"",
                parentname:"",
                storename:"",
                paydate:"",
            },
            dialogVisible:false,
            storeData:[],
            inteboNotDePositData:[],
            searchParms:{
                parentid:"",
                storeid:"",
            },
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getInteboDepositByFinished();
    },
    methods:{
        updateInteboDeposit(){
            this.queryLoadBtton=true;
            this.$postw("intebosale/updateInteboDeposit",this.inteboDePostit).then(res=>{
                this.getInteboDepositByFinished();
                this.$message({message: "保存成功", type: 'success'});
                this.dialogVisible=false;
                this.queryLoadBtton=false;
            });
        },
        openPay(scope){
            this.dialogVisible=true;
            this.curIndex=scope.$index;
            this.inteboDePostit=scope.row;
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[1]){
                this.searchParms.parentid=val[0];
                this.searchParms.storeid=val[1];
            }
            else{
                if(val[0]){
                    this.searchParms.parentid=val[0];
                }
            }
            this.getInteboDepositByFinished();
        },
        getInteboDepositByFinished(){
            this.$post("intebosale/getInteboDepositByFinished",{parentid: this.searchParms.parentid,storeid:this.searchParms.storeid}).then(res=>{
                this.inteboNotDePositData=res.object;
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.notpay .el-input-number .el-input__inner {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/notbackdj.vue